const touchMove: any = {
    /*
    * touch代替click
    * 方法接收参数func
    * 数据接收参数arg
    * 用法-传参：v-touchclick='{"func": add, "arg": item}'
    * 用法-不传参：v-touchclick='add'
    */
    bind(el: any, binding: any) {
        let startx: number, startY: number; //开始触摸的坐标
        let nowx:number,progress:any,mouseDom:any,allwh:any,percent:any,parentLeft:any;
        let ww = document.documentElement.clientWidth;
        let wh = window.innerHeight;    
        el.addEventListener('touchstart', (e: any) => {
            e.stopPropagation();
            if (binding.expression) {
                progress = document.getElementById("progress");
                mouseDom = document.getElementById("mouseDom");
                parentLeft = progress.offsetLeft
                allwh = progress.clientWidth;
                startx = e.touches[0].clientX;
                if (startx < parentLeft) {
                    startx = parentLeft
                }
                percent = ((startx-parentLeft) / allwh)
                if (percent >1 ) {
                    percent = 1
                }
                mouseDom.style.left = percent * 100 + '%'
            }
        });
        el.addEventListener('touchmove', (e: any) => {    //阻止滑动触发输入（增加滑动触发范围）
            if (binding.expression) {
                nowx = e.touches[0].clientX
                if (nowx < parentLeft) {
                    nowx = parentLeft
                }
                percent = ((nowx-parentLeft) / allwh)
                if (percent >1 ) {
                    percent = 1
                }
                mouseDom.style.left = percent * 100 + '%'
            }
        });
        el.addEventListener('touchend', (e: any) => {    //触发输入
            e.stopPropagation();
            if (binding.expression) {             
                binding.value(percent)            
            }
        });
    }
}

export default touchMove
